import React, { type ReactNode, type FC, useState } from 'react';
import { InputText, Select } from '@g2u/ui-kit';
import { debounce } from 'lodash';

import { type JsonDataItem, type WithOptionalDataTest } from 'types';
import { type DefaultOptionType } from 'antd/es/select';

export namespace AddressLookup {
  export type Props = {
    name: string;
    className?: string;
    label?: string | ReactNode;
    required?: boolean;
    placeholder?: string;
    initialValue?: string;
    onAddressSearch: (value: string) => void;
    onAddressSelect: (option: JsonDataItem) => void;
    addressOptions: DefaultOptionType[];
    readonly?: boolean;
    isManual?: boolean;
  } & WithOptionalDataTest;

  export const $: FC<Props> = (props) => {
    const {
      placeholder,
      name,
      label,
      required = true,
      className,
      onAddressSearch,
      onAddressSelect,
      addressOptions,
      initialValue,
      dataTestId,
      readonly,
      isManual,
    } = props;
    const [searchedValue, setSearchedValue] = useState<string>('');

    return (
      <>
        {isManual ? (
          <InputText.$
            dataTestId={dataTestId}
            name={name}
            label={label}
            fullWidth
            placeholder="Street Address Line 1"
            initialValue={initialValue}
            className={className}
            rules={[{ required }]}
            data-dd-privacy="mask"
          />
        ) : (
          <Select.$
            name={name}
            showSearch
            placeholder={placeholder}
            defaultActiveFirstOption={false}
            suffixIcon={null}
            filterOption={false}
            onSearch={debounce((value: string) => {
              setSearchedValue(value?.trim());
              value?.trim().length > 2 && onAddressSearch(value);
            }, 500)}
            onSelect={(_, option) => {
              onAddressSelect(option);
            }}
            notFoundContent={null}
            initialValue={initialValue}
            label={label}
            required={required}
            options={searchedValue.length > 2 ? addressOptions : []}
            fullWidth
            className={className}
            dataTestId={dataTestId}
            rules={[{ required }]}
            readonly={readonly}
            optionLabelProp="value"
            data-dd-privacy="mask"
          />
        )}
      </>
    );
  };
}
